/* ==========================================================================
   Yumeka — sections personnalisées
   Comportements des trois sections : carrousel d'avis vidéo (.uvc), avis photo
   et vidéo (.arv), FAQ à média (.fqv).

   Une règle traverse tout le fichier : rien ne se charge avant qu'on le
   demande. Les vidéos sont posées en `preload="none"`, les intégrations
   YouTube et Vimeo ne sont insérées qu'au premier appui — une page qui monte
   six lecteurs tiers au chargement dépose leurs traceurs avant même que la
   visiteuse ait décidé de regarder quoi que ce soit.

   Sans JavaScript, chaque section reste lisible : les vignettes s'affichent,
   les accordéons s'ouvrent, seule la lecture en place est perdue.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Une seule vidéo joue à la fois sur toute la page. Deux bandes-son
     simultanées sont une faute, pas une possibilité. */
  var enCours = null;

  function arreteTout(sauf) {
    if (enCours && enCours !== sauf) {
      if (enCours.pause) { try { enCours.pause(); } catch (e) {} }
      var carte = enCours.closest ? enCours.closest('[data-uvc-card], [data-arv-card], [data-fqv-media]') : null;
      if (carte) carte.classList.remove('is-playing');
    }
    enCours = sauf || null;
  }

  /* ---------- lecture d'une carte ----------------------------------------
     La vidéo Shopify est déjà dans le DOM mais vide de données : `preload`
     vaut « none ». Pour une source externe, l'élément est fabriqué au premier
     appui, jamais avant. */
  function basculeCarte(carte, boutonSelecteur) {
    var video = $('video', carte);

    if (!video) {
      var src = carte.getAttribute('data-uvc-src');
      if (!src) return;
      video = document.createElement('video');
      video.src = src;
      video.playsInline = true;
      video.preload = 'none';
      video.setAttribute('playsinline', '');
      carte.insertBefore(video, $(boutonSelecteur, carte));
    }

    if (video.paused) {
      arreteTout(video);
      carte.classList.add('is-playing');
      var p = video.play();
      /* La lecture peut être refusée — économie de données, mode basse
         consommation. Mieux vaut revenir à la vignette que laisser un bouton
         « pause » sur une vidéo à l'arrêt. */
      if (p && p.catch) {
        p.catch(function () { carte.classList.remove('is-playing'); arreteTout(null); });
      }
      video.onended = function () { carte.classList.remove('is-playing'); arreteTout(null); };
    } else {
      video.pause();
      carte.classList.remove('is-playing');
      arreteTout(null);
    }
  }

  /* ---------- 1. carrousel d'avis vidéo ----------------------------------- */

  $$('[data-uvc-track]').forEach(function (piste) {
    piste.addEventListener('click', function (e) {
      var bouton = e.target.closest && e.target.closest('[data-uvc-play]');
      if (!bouton) return;
      basculeCarte(bouton.closest('[data-uvc-card]'), '[data-uvc-play]');
    });
  });

  /* Une vidéo qui sort de l'écran continuerait de jouer, avec le son, sans que
     personne ne la voie. On l'arrête. */
  if ('IntersectionObserver' in window) {
    var veille = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (entree) {
        if (entree.isIntersecting) return;
        var v = $('video', entree.target);
        if (v && !v.paused) {
          v.pause();
          entree.target.classList.remove('is-playing');
          if (enCours === v) enCours = null;
        }
      });
    }, { threshold: 0.25 });
    $$('[data-uvc-card], [data-arv-card]').forEach(function (c) { veille.observe(c); });
  }

  /* ---------- 2. avis photo et vidéo -------------------------------------- */

  $$('[data-arv-card]').forEach(function (carte) {
    var bouton = $('[data-arv-play]', carte);
    if (!bouton) return;
    bouton.addEventListener('click', function () { basculeCarte(carte, '[data-arv-play]'); });
  });

  /* ---------- 3. FAQ à média ---------------------------------------------- */

  /* Un seul accordéon ouvert à la fois. `toggle` plutôt que `click` : il part
     aussi à l'ouverture au clavier, que `click` manquerait. */
  $$('[data-fqv-list]').forEach(function (liste) {
    var items = $$('details', liste);
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (autre) { if (autre !== item) autre.open = false; });
      });
    });
  });

  $$('[data-fqv-media]').forEach(function (media) {
    var bouton = $('[data-fqv-play]', media);
    if (!bouton) return;

    bouton.addEventListener('click', function () {
      var video = $('video', media);
      if (video) {
        /* Pas de `controls = true` ici. Les commandes natives sont grises,
           differentes d'un navigateur a l'autre, et posent une barre plus une
           icone de plein ecran par-dessus la video — c'est exactement ce qu'on
           ne veut pas voir. Le bouton violet fait tout : il lit, il met en
           pause, et il ne montre rien d'autre. */
        if (video.paused) {
          arreteTout(video);
          media.classList.add('is-playing');
          var pr = video.play();
          if (pr && pr.catch) { pr.catch(function () { media.classList.remove('is-playing'); arreteTout(null); }); }
          video.onended = function () { media.classList.remove('is-playing'); arreteTout(null); };
        } else {
          video.pause();
          media.classList.remove('is-playing');
          arreteTout(null);
        }
        return;
      }

      /* Intégration externe : l'iframe n'est fabriquée qu'ici. Tant que la
         visiteuse n'a pas appuyé, aucune requête ne part chez YouTube ou
         Vimeo, donc aucun traceur n'est déposé. */
      var id = media.getAttribute('data-fqv-embed');
      var type = media.getAttribute('data-fqv-type');
      if (!id) return;

      var frame = document.createElement('iframe');
      frame.allow = 'autoplay; fullscreen; picture-in-picture';
      frame.setAttribute('allowfullscreen', '');
      frame.title = 'Vidéo';
      frame.loading = 'lazy';
      frame.src = type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
        : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      media.appendChild(frame);
      media.classList.add('is-playing');
    });
  });
})();

/* ==========================================================================
   Avis vidéo — carrousel centré (.vlx)
   Ajouté après coup, dans son propre bloc : le reste du fichier ne le connaît
   pas et n'a pas à le connaître.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  $$('[data-vlx]').forEach(function (scene) {
    var piste  = $('[data-vlx-track]', scene);
    var cartes = $$('[data-vlx-card]', piste);
    if (!piste || !cartes.length) return;

    var prev  = $('[data-vlx-prev]', scene);
    var next  = $('[data-vlx-next]', scene);
    var modal = $('[data-vlx-modal]', scene.closest('.vlx'));
    var scene_ = $('[data-vlx-player]', scene.closest('.vlx'));

    /* ---------- échelle selon la distance au centre ----------------------
       Calculée à chaque image plutôt qu'à l'arrivée : pendant un balayage au
       doigt, la carte grandit progressivement au lieu de sauter à la fin. Les
       paliers reprennent la référence — 1 au centre, 0,90 pour les voisines,
       0,79 au-delà. */
    var tick = false;
    function peindre() {
      var centre = piste.scrollLeft + piste.clientWidth / 2;
      var actif = 0, plusProche = Infinity;

      cartes.forEach(function (c, i) {
        var milieu = c.offsetLeft + c.offsetWidth / 2;
        var ecart = Math.abs(milieu - centre) / c.offsetWidth;
        if (ecart < plusProche) { plusProche = ecart; actif = i; }
        /* 1 au centre, 0,79 à deux cartes et au-delà. */
        var s = Math.max(0.79, 1 - ecart * 0.105);
        c.style.setProperty('--s', s.toFixed(3));
      });

      if (prev) prev.disabled = piste.scrollLeft <= 2;
      if (next) next.disabled = piste.scrollLeft >= piste.scrollWidth - piste.clientWidth - 2;
      piste.dataset.actif = actif;
      tick = false;
    }

    function planifier() {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(peindre);
    }

    piste.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    /* Les images arrivent après le premier calcul et changent les positions. */
    $$('img', piste).forEach(function (im) {
      if (!im.complete) im.addEventListener('load', planifier, { once: true });
    });
    /* Au chargement, c'est la carte du milieu qui est au centre, comme sur la
       reference — pas la premiere. Sans defilement doux : la page ne doit pas
       s'ouvrir sur une animation que personne n'a demandee. */
    function centrerMilieu() {
      var i = Math.floor(cartes.length / 2);
      var c = cartes[i];
      if (!c) return;
      piste.scrollLeft = c.offsetLeft - (piste.clientWidth - c.offsetWidth) / 2;
      peindre();
    }
    centrerMilieu();
    /* Les images arrivent apres et deplacent tout : on recentre une fois
       qu'elles ont leur taille. */
    window.addEventListener('load', centrerMilieu, { once: true });

    peindre();

    /* Le temps d'un saut par flèche, on rend la main aux transitions ; pendant
       un balayage, on les coupe pour que l'échelle suive le doigt. */
    var minuteur;
    piste.addEventListener('scroll', function () {
      piste.classList.add('is-dragging');
      clearTimeout(minuteur);
      minuteur = setTimeout(function () { piste.classList.remove('is-dragging'); }, 140);
    }, { passive: true });

    function aller(delta) {
      var i = Math.min(cartes.length - 1, Math.max(0, (parseInt(piste.dataset.actif, 10) || 0) + delta));
      var c = cartes[i];
      piste.scrollTo({
        left: c.offsetLeft - (piste.clientWidth - c.offsetWidth) / 2,
        behavior: doux ? 'smooth' : 'auto'
      });
    }
    if (prev) prev.addEventListener('click', function () { aller(-1); });
    if (next) next.addEventListener('click', function () { aller(1); });

    /* Flèches du clavier quand la piste a le focus. Le défilement natif ne les
       gère qu'en pixels ; ici on veut passer d'un avis au suivant. */
    piste.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); aller(-1); }
    });

    /* ---------- lecture en fenêtre --------------------------------------
       La source n'est posée qu'ici, et retirée à la fermeture : rien ne se
       télécharge tant que personne n'a demandé à voir. */
    if (!modal || !scene_) return;

    function ouvrir(src) {
      scene_.innerHTML = '';
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      scene_.appendChild(v);
      if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
    }

    function fermer() {
      var v = $('video', scene_);
      if (v) { try { v.pause(); } catch (e) {} }
      scene_.innerHTML = '';
      if (modal.close) modal.close(); else modal.removeAttribute('open');
    }

    piste.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-vlx-play]');
      if (!b) return;
      var src = b.closest('[data-vlx-card]').getAttribute('data-vlx-src');
      if (src) ouvrir(src);
    });

    var fermeture = $('[data-vlx-close]', modal);
    if (fermeture) fermeture.addEventListener('click', fermer);

    /* Clic à l'extérieur du lecteur. `<dialog>` reçoit le clic du fond, donc
       il suffit de vérifier que la cible n'est pas dans le lecteur. */
    modal.addEventListener('click', function (e) {
      if (!scene_.contains(e.target) && !e.target.closest('[data-vlx-close]')) fermer();
    });
    /* Échap est géré par `<dialog>`, mais il faut encore vider le lecteur. */
    modal.addEventListener('close', function () { scene_.innerHTML = ''; });
  });
})();

/* ==========================================================================
   Lecture automatique au défilement — toutes les vidéos du site
   --------------------------------------------------------------------------
   Une vidéo se lance quand elle entre dans l'écran, s'arrête quand elle en
   sort. Quatre garde-fous, tous nécessaires :

   1. Le son est coupé. Aucun navigateur n'autorise une lecture automatique
      sonore, et il ne le fera pas : la demande serait simplement refusée et
      rien ne jouerait. Le bouton violet, lui, rend le son — un appui délibéré
      vaut consentement, ce que le défilement ne vaut pas.

   2. `prefers-reduced-motion` coupe tout. C'est un réglage d'accessibilité,
      pas une préférence esthétique : certaines personnes en ont besoin.

   3. Le mode économie de données coupe tout. Une page qui télécharge cinq
      vidéos sans qu'on ait rien demandé, sur un forfait compté, est une faute.

   4. Une vidéo mise en pause à la main ne repart jamais toute seule. Le choix
      de la visiteuse l'emporte sur le défilement.
   ========================================================================== */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  /* Les deux réglages ci-dessous coupent la lecture automatique, et rien
     d'autre. Ils sortaient de la fonction entière, ce qui emportait aussi le
     gestionnaire du bouton violet plus bas : sur un téléphone en mouvement
     réduit ou en économie de données, appuyer sur Lire ne rendait plus le son.
     La lecture au défilement se coupe donc toujours, mais les commandes, elles,
     restent branchées dans tous les cas. */
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var eco = navigator.connection && navigator.connection.saveData;
  var autoAutorisee = !reduit && !eco;

  /* Sélecteur étendu pour couvrir toutes les sections vidéo du thème :
     FAQ à média, Avis photo/vidéo, Carrousel avis vidéo, Reels, Lots, Hero À propos,
     et la nouvelle section UGC Video Reviews (.uvc-ugc). */
  var SEL = '.fqv__media video, .arv__media video, .uvc__card video, .lti video, .hab video, .uvc-ugc__card video, .reels__item video, .vlx__card video';

  function conteneur(v) {
    return v.closest('[data-fqv-media], [data-arv-card], [data-uvc-card], [data-vlx-card], [data-reel], .uvc-ugc__card, .reels__item') || v.parentElement;
  }

  /* `is-playing` est ce qui rend la vidéo visible : sans elle, la CSS la laisse
     à `opacity: 0` et c'est l'affiche qu'on voit. Elle était posée juste après
     l'appel à `play()`, sans attendre de savoir s'il avait abouti. Quand le
     navigateur refuse — économie d'énergie sur iPhone, onglet en arrière-plan —
     la vidéo passait quand même devant l'affiche et y restait figée sur une
     image noire : de l'extérieur, exactement « la vidéo ne se lance pas ».

     C'est donc l'évènement `playing`, émis par le navigateur lui-même quand des
     images défilent vraiment, qui pose la classe. Un refus laisse l'affiche en
     place et le bouton violet disponible. */
  function marquerEnLecture(v) {
    var c = conteneur(v);
    if (c) c.classList.add('is-playing');
  }
  function marquerArretee(v) {
    var c = conteneur(v);
    if (c) c.classList.remove('is-playing');
  }

  var obs = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      var v = e.target;
      if (v.dataset.pauseManuelle === '1') return;

      /* Un média plus haut que l'écran ne peut jamais être visible à 35 % : le
         maximum atteignable est la hauteur de l'écran divisée par la sienne. Le
         seuil seul suffisait sur ordinateur et ne se déclenchait jamais sur les
         formats verticaux, sur un téléphone. On accepte donc aussi le cas où le
         média occupe déjà la moitié de la hauteur visible. */
      var assezVisible = e.intersectionRatio >= 0.35 ||
        (e.intersectionRect && e.intersectionRect.height >= window.innerHeight * 0.5);

      if (e.isIntersecting && assezVisible) {
        /* Muet, playsinline, loop : sans les trois, la lecture auto est
           refusée sur mobile et la vidéo reste noire. */
        v.muted = true;
        v.setAttribute('muted', '');
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.loop = true;
        var p = v.play();
        if (p && p.then) {
          p.then(function () { marquerEnLecture(v); })
           .catch(function () { marquerArretee(v); });
        }
      } else if (!e.isIntersecting) {
        if (!v.paused) { try { v.pause(); } catch (err) {} }
        marquerArretee(v);
      }
    });
  }, { threshold: [0, 0.35], rootMargin: '50px' });

  function armer() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (v) {
      if (v.dataset.autoArme === '1') return;
      v.dataset.autoArme = '1';

      /* Le navigateur est seul à savoir si des images défilent vraiment. On
         suit ses évènements plutôt que nos intentions : la vidéo ne passe
         devant l'affiche qu'une fois la lecture réellement commencée, quelle
         que soit la voie empruntée — défilement ou bouton violet. */
      v.addEventListener('playing', function () { marquerEnLecture(v); });
      v.addEventListener('pause', function () { marquerArretee(v); });

      /* `preload="none"` empêcherait la lecture automatique de démarrer : on
         passe à `metadata`, qui ne télécharge que l'entête. */
      if (v.preload === 'none') v.preload = 'metadata';
      /* S'assurer que les attributs critiques sont présents même si le Liquid
         ne les a pas rendus (ex: vidéo ajoutée dynamiquement). */
      v.setAttribute('playsinline', '');
      v.setAttribute('muted', '');
      v.loop = true;

      /* Le mouvement réduit et l'économie de données coupent la lecture au
         défilement : la vidéo est préparée et commandable, mais rien ne
         l'observe, donc rien ne la démarre sans un appui. */
      if (autoAutorisee) obs.observe(v);
    });
  }

  /* Un appui sur le bouton violet reprend la main : le son revient, et le
     défilement ne redémarrera plus cette vidéo-là. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fqv-play], [data-arv-play], [data-uvc-play], [data-vlx-play], [data-reel-ctl]');
    if (!b) return;
    var c = b.closest('[data-fqv-media], [data-arv-card], [data-uvc-card], [data-vlx-card], [data-reel], .uvc-ugc__card');
    var v = c && c.querySelector('video');
    if (!v) return;
    if (v.paused) {
      v.dataset.pauseManuelle = '0';
      v.muted = false;
      v.removeAttribute('muted');
      v.loop = false;
    } else {
      v.dataset.pauseManuelle = '1';
    }
  }, true);

  armer();
  window.addEventListener('load', armer, { once: true });
  /* L'éditeur de thème remonte les sections à chaud : sans ça, une section
     rechargée perdrait la lecture automatique jusqu'au prochain rafraîchissement. */
  document.addEventListener('shopify:section:load', armer);
})();

/* ==========================================================================
   Mur d'avis (.rwl) — filtres et « voir plus »
   Tout se joue sur des cartes déjà rendues : aucune requête, aucun saut de
   page. Filtrer 270 avis côté serveur demanderait un rechargement à chaque
   clic pour un gain nul — le HTML est déjà là.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  $$('[data-rwl]').forEach(function (sec) {
    var cartes = $$('[data-rwl-card]', sec);
    var bouton = $('[data-rwl-more]', sec);
    var chips  = $$('[data-rwl-filter]', sec);
    if (!cartes.length) return;

    var parPage = parseInt(sec.getAttribute('data-per-page'), 10) || 9;
    var note = 0;      // 0 = toutes
    var montre = parPage;

    function visibles() {
      return note === 0
        ? cartes
        : cartes.filter(function (c) { return c.getAttribute('data-note') === String(note); });
    }

    function peindre() {
      var liste = visibles();
      cartes.forEach(function (c) { c.hidden = true; });
      liste.slice(0, montre).forEach(function (c) { c.hidden = false; });

      if (bouton) {
        var manque = liste.length - montre;
        bouton.hidden = manque <= 0;
      }

      /* Un filtre qui ne renverrait rien est désactivé plutôt que masqué :
         le faire disparaître déplacerait les autres sous le doigt. */
      chips.forEach(function (ch) {
        var n = parseInt(ch.getAttribute('data-rwl-filter'), 10);
        if (n === 0) return;
        var combien = cartes.filter(function (c) { return c.getAttribute('data-note') === String(n); }).length;
        ch.disabled = combien === 0;
      });
    }

    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        note = parseInt(ch.getAttribute('data-rwl-filter'), 10) || 0;
        montre = parPage;   // un changement de filtre repart du début
        chips.forEach(function (o) { o.classList.toggle('is-on', o === ch); });
        peindre();
      });
    });

    if (bouton) {
      bouton.addEventListener('click', function () {
        var avant = visibles().slice(0, montre).length;
        montre += parPage;
        peindre();
        /* Le focus part sur la première carte révélée : sans cela, la personne
           au clavier resterait sur un bouton qui vient de disparaître. */
        var liste = visibles();
        var premiere = liste[avant];
        if (premiere) {
          premiere.setAttribute('tabindex', '-1');
          premiere.focus({ preventScroll: true });
        }
      });
    }

    peindre();
  });
})();

/* ==========================================================================
   TRACKING — Recherche commande via API Shopify
   --------------------------------------------------------------------------
   Utilise l'endpoint /orders/{order_number}.json?email=...
   Affiche une timeline visuelle des étapes.
========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initTracking() {
    /* Ne se branche que sur un formulaire explicitement marque. Le repli sur
       « le premier formulaire de #tracker-search » attrapait aussi celui qui
       part vers l'application de suivi : le script interceptait alors l'envoi
       pour interroger un point d'entree Shopify qui repond 404, et la
       navigation vers l'application n'avait jamais lieu. */
    var form = $('[data-tracker-form]');
    var results = $('#tracker-results');
    var empty = $('#tracker-empty');
    var search = $('#tracker-search');

    if (!form || !results) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var orderNumber = form.querySelector('[name="order_number"]').value.trim();
      var email = form.querySelector('[name="email"]').value.trim();

      if (!orderNumber || !email) return;

      /* UI loading */
      results.hidden = false;
      empty.hidden = true;
      results.innerHTML = '<div class="trk-tracker__loading"><div class="trk-tracker__spinner" aria-hidden="true"></div><p>Recherche de votre commande…</p></div>';
      search.style.opacity = '.5';
      search.style.pointerEvents = 'none';

      /* Nettoyer le numéro (enlever # si présent) */
      var cleanNumber = orderNumber.replace(/^#/, '');

      /* Appel API Shopify — endpoint public pour le statut de commande */
      var url = '/orders/' + encodeURIComponent(cleanNumber) + '.json?email=' + encodeURIComponent(email);

      fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (r.status === 404) throw new Error('not_found');
          if (!r.ok) throw new Error('error_' + r.status);
          return r.json();
        })
        .then(function (data) {
          var order = data.order;
          if (!order) throw new Error('not_found');
          renderTimeline(order);
        })
        .catch(function (err) {
          if (err.message === 'not_found') {
            results.hidden = true;
            empty.hidden = false;
          } else {
            results.innerHTML = '<div class="trk-tracker__empty"><div class="trk-tracker__empty-icon" aria-hidden="true"><svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg></div><h3>Erreur</h3><p>Impossible de récupérer les informations. Réessayez dans un instant.</p></div>';
          }
        })
        .finally(function () {
          search.style.opacity = '1';
          search.style.pointerEvents = 'auto';
        });
    });
  }

  function renderTimeline(order) {
    var results = $('#tracker-results');
    if (!results) return;

    /* Déterminer les étapes selon le statut financier/fulfillment */
    var financial = order.financial_status;      // paid, pending, refunded, etc.
    var fulfillment = order.fulfillment_status;  // fulfilled, partial, null
    var fulfillments = order.fulfillments || [];

    var steps = [
      { key: 'confirmed',   label: 'Commande confirmée',     time: order.created_at,       icon: 'check-circle' },
      { key: 'preparing',   label: 'Préparation en cours',   time: null,                   icon: 'package' },
      { key: 'shipped',     label: 'Expédié',                time: firstFulfillmentDate(), icon: 'truck' },
      { key: 'delivered',   label: 'Livré',                  time: deliveryDate(),         icon: 'check-circle-2' }
    ];

    function firstFulfillmentDate() {
      if (fulfillments.length) {
        return fulfillments[0].created_at || fulfillments[0].updated_at;
      }
      return null;
    }
    function deliveryDate() {
      if (fulfillment === 'fulfilled' && fulfillments.length) {
        return fulfillments[0].delivery_date || fulfillments[0].updated_at;
      }
      return null;
    }

    /* Calculer l'état de chaque étape */
    var currentReached = false;
    steps.forEach(function (step) {
      if (currentReached) {
        step.state = 'pending';
        return;
      }
      if (step.key === 'confirmed' && financial !== 'pending') {
        step.state = 'complete';
        currentReached = true;
      } else if (step.key === 'preparing' && financial !== 'pending' && !fulfillment) {
        step.state = 'current';
        currentReached = true;
      } else if (step.key === 'shipped' && fulfillment) {
        step.state = fulfillment === 'fulfilled' ? 'complete' : 'current';
        currentReached = fulfillment === 'fulfilled';
      } else if (step.key === 'delivered' && fulfillment === 'fulfilled') {
        step.state = 'complete';
      } else {
        step.state = 'pending';
      }
    });

    /* Icônes SVG */
    var icons = {
      'check-circle':    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>',
      'package':         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12V7H5"/><path d="M16 7v5"/><circle cx="9" cy="17" r="2"/><circle cx="20" cy="17" r="2"/></svg>',
      'truck':           '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 17V9a2 2 0 0 0-2-2H5a2 2 0 0 0 0 4h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>',
      'check-circle-2':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="16 8 12 12 8 8"/></svg>'
    };

    function formatDate(iso) {
      if (!iso) return '';
      var d = new Date(iso);
      return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', hour: '2digit', minute: '2digit' });
    }

    var html = '<div class="trk-timeline" role="list" aria-label="Étapes de livraison">';
    steps.forEach(function (step, i) {
      var isLast = i === steps.length - 1;
      html += '<div class="trk-timeline__item is-' + step.state + '" role="listitem">';
      html += '<span class="trk-timeline__status">';
      if (step.state === 'complete') html += 'Terminé';
      else if (step.state === 'current') html += 'En cours';
      else html += 'À venir';
      html += '</span>';
      html += '<h4 class="trk-timeline__title">' + step.label + '</h4>';
      html += '<div class="trk-timeline__meta">';
      if (step.time) html += '<time>' + formatDate(step.time) + '</time>';
      if (step.key === 'shipped' && fulfillments[0]?.tracking_company) {
        html += '<span class="trk-timeline__carrier">' + fulfillments[0].tracking_company + '</span>';
      }
      if (step.key === 'shipped' && fulfillments[0]?.tracking_url) {
        html += '<a class="trk-timeline__tracking-link" href="' + fulfillments[0].tracking_url + '" target="_blank" rel="noopener">Suivre le colis →</a>';
      }
      html += '</div>';
      html += '</div>';
    });
    html += '</div>';

    /* Infos commande en haut */
    var headerHtml = '<div class="trk-tracker__order-header">';
    headerHtml += '<p class="trk-tracker__order-number">Commande <strong>#' + order.order_number + '</strong></p>';
    headerHtml += '<p class="trk-tracker__order-date">Passée le ' + formatDate(order.created_at) + '</p>';
    headerHtml += '<p class="trk-tracker__order-total">Total : ' + (order.total_price / 100).toFixed(2).replace('.', ',') + ' €</p>';
    headerHtml += '</div>';

    results.innerHTML = headerHtml + html;
  }

  /* Exposer pour shopify:section:load */
  window.initTracking = initTracking;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }

  /* Re-initialiser quand l'éditeur de thème recharge la section */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail.sectionId && document.getElementById(e.detail.sectionId)?.querySelector('#tracker-search')) {
      initTracking();
    }
  });
})();

/* ==========================================================================
   FAQ Accordéons — un seul ouvert à la fois (tracking + ambassador)
   ========================================================================== */
(function () {
  'use strict';

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  $$('[data-trk-faq-list], [data-amb-faq-list]').forEach(function (list) {
    var items = $$('details', list);
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  });
})();

/* ---------- Chambre par coloris ------------------------------------------- */
/* Le changement n'est qu'une permutation de classe entre deux images déjà
   chargées. Aucun appel réseau, aucune mesure : c'est ce qui rend la bascule
   instantanée quel que soit le nombre de coloris.

   La délégation vit sur la section et non sur chaque pastille : une section
   re-rendue par l'éditeur reste vivante sans qu'on ait à réarmer quoi que ce
   soit. */
(function () {
  'use strict';

  function poser(scene, coloris) {
    var imgs = scene.querySelectorAll('[data-crm-img]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].classList.toggle('is-on', imgs[i].getAttribute('data-crm-img') === coloris);
    }
    var dots = scene.querySelectorAll('[data-crm-dot]');
    for (var j = 0; j < dots.length; j++) {
      var actif = dots[j].getAttribute('data-crm-dot') === coloris;
      dots[j].classList.toggle('is-on', actif);
      dots[j].setAttribute('aria-checked', actif ? 'true' : 'false');
    }
    var nom = scene.querySelector('[data-crm-nom]');
    if (nom) nom.textContent = coloris;
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-crm-dot]');
    if (!dot) return;
    var scene = dot.closest('[data-crm]');
    if (!scene) return;
    poser(scene, dot.getAttribute('data-crm-dot'));
  });

  /* Flèches : un groupe radio se parcourt au clavier, sinon seule la première
     pastille est atteignable et les neuf autres n'existent pas pour qui
     n'utilise pas de souris. */
  document.addEventListener('keydown', function (e) {
    var dot = e.target.closest && e.target.closest('[data-crm-dot]');
    if (!dot) return;
    var suivant = e.key === 'ArrowRight' || e.key === 'ArrowDown';
    var precedent = e.key === 'ArrowLeft' || e.key === 'ArrowUp';
    if (!suivant && !precedent) return;
    e.preventDefault();

    var scene = dot.closest('[data-crm]');
    var dots = Array.prototype.slice.call(scene.querySelectorAll('[data-crm-dot]'));
    var i = dots.indexOf(dot);
    var cible = dots[(i + (suivant ? 1 : -1) + dots.length) % dots.length];
    cible.focus();
    poser(scene, cible.getAttribute('data-crm-dot'));
  });
})();

/* ==========================================================================
   Bannières défilantes (.bnr)
   Le défilement lui-même n'a besoin de rien : la piste est un scroll natif
   avec scroll-snap, donc le doigt, la molette et le clavier fonctionnent
   script éteint. Ce qui suit ne sert qu'aux flèches et à la pastille active.

   Aucun écouteur de défilement, conformément au reste du thème : c'est un
   IntersectionObserver posé sur la piste elle-même qui dit quelle bannière
   est à l'écran. Un handler de scroll se déclencherait des dizaines de fois
   par geste pour la même information.
   ========================================================================== */
(function () {
  'use strict';

  var scenes = document.querySelectorAll('[data-bnr]');
  if (!scenes.length) return;

  /* Declaree ici et pas empruntee au bloc voisin : chaque IIFE de ce fichier a
     sa propre portee, et une variable lue depuis une autre leverait une
     ReferenceError au premier clic — que le controle de syntaxe ne voit pas. */
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(scenes, function (scene) {
    var piste = scene.querySelector('[data-bnr-track]');
    if (!piste) return;

    var vues  = piste.querySelectorAll('[data-bnr-slide]');
    var prev  = scene.querySelector('[data-bnr-prev]');
    var suiv  = scene.querySelector('[data-bnr-next]');
    /* Selon la section, les pastilles sont dans la scène ou juste en dessous.
       On regarde d'abord dedans, puis dans la section porteuse. Jamais de repli
       sur `document` : il ramasserait les pastilles de tous les carrousels de
       la page, et cliquer sur l'une piloterait les autres. */
    var dots = scene.querySelectorAll('[data-bnr-dot]');
    if (!dots.length) {
      var boite = scene.closest('.bnr');
      dots = boite ? boite.querySelectorAll('[data-bnr-dot]') : [];
    }
    if (vues.length < 2) return;

    var actif = 0;

    /* L'indice se déduit de la position de la piste, jamais d'un compteur tenu
       à part : un compteur diverge dès que la visiteuse fait glisser au doigt,
       puisque personne ne l'en informe. */
    function indexCourant() {
      var pas = vues[1].offsetLeft - vues[0].offsetLeft;
      if (pas <= 0) { return 0; }
      var i = Math.round(piste.scrollLeft / pas);
      if (i < 0) { i = 0; }
      if (i > vues.length - 1) { i = vues.length - 1; }
      return i;
    }

    function aller(i) {
      if (i < 0) { i = 0; }
      if (i > vues.length - 1) { i = vues.length - 1; }
      /* `scrollIntoView` viserait aussi la fenêtre et ferait sauter la page
         verticalement. On écrit la position de la piste, et elle seule.

         L'écart est mesuré depuis la première vue et non depuis la piste : une
         piste qui porte une marge latérale décalerait le calcul de toute cette
         marge, et chaque vue s'arrêterait à côté. */
      var cible = vues[i].offsetLeft - vues[0].offsetLeft;
      var reste = piste.scrollWidth - piste.clientWidth;
      if (cible > reste) { cible = reste; }

      piste.scrollTo({ left: cible, behavior: reduit ? 'auto' : 'smooth' });

      /* Peint tout de suite avec la position visée. Sans cela, l'état ne serait
         mis à jour que par l'observateur, qui se déclenche aux franchissements
         de seuil — donc souvent en plein défilement doux, et le dernier appel
         fige alors une position intermédiaire. */
      peindre(i, cible);
    }

    function peindre(i, x) {
      actif = i;
      var pos = (typeof x === 'number') ? x : piste.scrollLeft;
      Array.prototype.forEach.call(dots, function (d, k) {
        if (k === i) { d.setAttribute('aria-current', 'true'); }
        else { d.removeAttribute('aria-current'); }
      });
      /* Aux extrémités, la flèche qui ne mène nulle part est désactivée plutôt
         que masquée : un bouton qui disparaît déplace ses voisins.

         L'état se lit sur la position de la piste et non sur l'indice actif.
         À plusieurs vues par écran, la fin du défilement arrive alors que la
         dernière vue n'est pas l'active — comparer les indices laisserait la
         flèche allumée sur un bouton qui ne fait plus rien. */
      var reste = piste.scrollWidth - piste.clientWidth;
      if (prev) { prev.disabled = pos <= 2; }
      if (suiv) { suiv.disabled = pos >= reste - 2; }
    }

    if (prev) { prev.addEventListener('click', function () { aller(actif - 1); }); }
    if (suiv) { suiv.addEventListener('click', function () { aller(actif + 1); }); }

    Array.prototype.forEach.call(dots, function (d, k) {
      d.addEventListener('click', function () { aller(k); });
    });

    if ('IntersectionObserver' in window) {
      /* L'observateur ne sert que de déclencheur : c'est la position de la
         piste qui donne l'indice. Retenir « la vue la plus visible » parmi les
         entrées reçues désignait la dernière du groupe quand trois vues
         tiennent à l'écran, et la pastille sautait à la troisième dès le
         premier appui. */
      var obs = new IntersectionObserver(function () {
        peindre(indexCourant());
      }, { root: piste, threshold: [0, 0.25, 0.5, 0.75, 1] });

      Array.prototype.forEach.call(vues, function (v) { obs.observe(v); });
    }

    /* Le mot de la fin revient à `scrollend`, émis une seule fois quand tout
       s'est arrêté — y compris après un glissement au doigt, que rien d'autre
       ne signale. Ce n'est pas un écouteur de défilement : il ne se déclenche
       pas pendant le geste. Les navigateurs qui ne le connaissent pas gardent
       l'état peint par l'appui, qui est déjà le bon. */
    if ('onscrollend' in window) {
      piste.addEventListener('scrollend', function () { peindre(indexCourant()); });
    }

    peindre(0);
  });
})();

/* ==========================================================================
   Étage vidéo de la description par étages (.etg__video)
   L'affiche est visible tant que rien ne joue. La classe qui révèle la vidéo
   est posée sur l'évènement `playing`, émis par le navigateur quand des images
   défilent vraiment — jamais sur l'intention de lire. Un navigateur qui refuse
   laisserait sinon une image noire à la place de l'affiche.
   ========================================================================== */
(function () {
  'use strict';

  var zones = document.querySelectorAll('[data-etg-video]');
  if (!zones.length) return;

  Array.prototype.forEach.call(zones, function (zone) {
    var bouton = zone.querySelector('[data-etg-play]');
    var video  = zone.querySelector('video');
    if (!bouton || !video) return;

    /* `preload="none"` empêche la lecture de démarrer sur certains
       navigateurs : on passe à `metadata`, qui ne télécharge que l'entête. */
    if (video.preload === 'none') { video.preload = 'metadata'; }

    video.addEventListener('playing', function () { zone.classList.add('is-playing'); });
    video.addEventListener('pause',   function () { zone.classList.remove('is-playing'); });
    video.addEventListener('ended',   function () { zone.classList.remove('is-playing'); });

    bouton.addEventListener('click', function () {
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      } else {
        video.pause();
      }
    });

    /* Une fois lancée, la vidéo se commande par un clic dessus : le bouton a
       disparu, et rien d'autre ne permettrait de la mettre en pause. */
    video.addEventListener('click', function () {
      if (!video.paused) { video.pause(); }
    });
  });
})();
